var _path, _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgBitbucketBlack(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.77 5c-.48 0-.839.44-.759.88L7.248 25.7c.08.52.52.88 1.04.88h15.665c.36 0 .679-.28.759-.64l3.277-20.02c.08-.48-.28-.88-.76-.88zm13.748 14.307h-4.996l-1.319-7.074h7.554z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: `url(#${_id})`,
    d: "M26.91 12.233h-7.193l-1.2 7.074h-4.995L7.648 26.3s.28.24.68.24h15.665c.36 0 .679-.28.759-.64z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 28.593,
    x2: 16.672,
    y1: 14.226,
    y2: 23.532,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#6C707E"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
});